// 采购区域
export let option_is_overseas = [
  { value: '1', text: '境内' },
  { value: '2', text: '境外' },
];

// 货源标识
export let isep = [
  { value: '1', text: 'EP货源' },
  { value: '2', text: '非EP货源' },
];

// 是否需要开发票
export let isinvoice = [
  { value: '0', text: '需要' },
  { value: '1', text: '不需要' },
];

// 付款条件
export let paymentterms = [
  { value: '0', text: '合同签订1日内付清' },
  { value: '1', text: '货到3个工作日内' },
  { value: '2', text: '货到30天' },
];

// 付款方式
export let paytype = [
  { value: '0', text: '银行转账' },
  { value: '1', text: '微信支付' },
  { value: '2', text: '支付宝支付' },
  { value: '3', text: '现金支付' },
  { value: '4', text: '支票' },
  { value: '5', text: 'PayPal' },
  { value: '6', text: '其他' },
];

// 结算方式
export let settlementtype = [
  { value: '0', text: '月结' },
  { value: '1', text: '货到付款' },
  { value: '2', text: '预付款+尾款' },
  { value: '3', text: '预付全款' },
  { value: '4', text: '其他' },
  { value: '5', text: '货到7天内付款' },
  { value: '6', text: '货到15天内付款' },
  { value: '7', text: '货到30天内付款' },
  { value: '8', text: '货到60天内付款' },
  { value: '9', text: '月结30天' },
  { value: '10', text: '月结45天' },
  { value: '11', text: '月结60天' },
];

// 结算方式
export let shippingmethods = [
  { value: '0', text: '自提' },
  { value: '1', text: '快递' },
  { value: '2', text: '包车' },
  { value: '3', text: '海运' },
  { value: '4', text: '空运' },
  { value: '5', text: '其他' },
  { value: '6', text: '货拉拉' },
];


// 税率
export let tax_rates = [ '0','1','3','6','13' ].map((item) => { return {text: item + '%', value: item} });



// 获取公司
export let getCompanyList = async (obj, params) => {
  let res = await obj.$post(obj.$api.stCompanyList, { page: params.page, name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
}

// 获取付款账户
export let getCorporation = async (obj, params) => {
  let res = await obj.$post(obj.$api.stCorporation, { page: params.page, name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
}

// 获取采购人员
export let getUserList = async (obj, params) => {
  let res = await obj.$post(obj.$api.stPurchaseUser, { page: params.page, nick_name: params.query });
  return res.data ? res.data.map( (item) => { return { text: item.nickname, value: item.id } } ) : [];
}

// 获取供应商
export let getSupplier = async (obj, params) => {
  let res = await obj.$post(obj.$api.stPurchaseSupplier, { page: params.page, name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
}

// 获取币种
export let getCurrency = async (obj, params) => {
  let res = await obj.$post(obj.$api.stCurrency, { page: params.page, currency_name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.tcur, value: item.tcur } } ) : [];
}

// 采购单产品
export let getPurchaseSku = async (obj, params) => {
  let res = await obj.$post(obj.$api.stPurchaseSku, { page: params.page, sku: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.sku, value: item.id } } ) : [];
}

// 仓库
export let getWarehouse = async (obj, params) => {
  let res = await obj.$post(obj.$api.stWarehouse, { page: params.page, name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
}

// 获取客户
export let getCustomer = async (obj, params) => {
  let res = await obj.$post(obj.$api.stCustomer, { page: params.page, customer_name: params.query });
  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
}

